module.exports = __webpack_public_path__ + "sd_slide_i4.jpg?b70ab6fd09b5e1af93b81e491d52ad0d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sd_slide_i4.jpg
// module id = 0
// module chunks = 0